<template lang="pug">
div(
  :id="nomeDiv",
  :class="{'justify-items-center': centralizarGrafico}"
)
</template>

<script>
import Plotly from '@/utils/custom-plotly.js'; // eslint-disable-line

export default {
  props: {
    nomeDiv: {
      type: String,
      required: true
    },
    dados: {
      type: Array,
      required: true
    },
    layout: {
      type: Object
    },
    options: {
      type: Object,
      default: () => { // eslint-disable-line
        return {
          displayModeBar: false,
          responsive: true
        }
      }
    },
    centralizarGrafico: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      gd: null
    }
  },
  mounted () {
    const d3 = Plotly.d3

    const widthInPercentOfParent = 100

    const gd3 = d3.select(`#${this.nomeDiv}`).style({
      width: widthInPercentOfParent + '%'
    })

    this.gd = gd3.node()
    Plotly.plot(this.gd, this.dados, this.layout, this.options)

    // Metodo usado para emitir um evento, quando a legenda for clicada, basta usar o evento 'updateGraficoOnLegendClick'
    this.gd.on('plotly_legendclick', (event) => {
      this.$emit('updateGraficoOnLegendClick', event.expandedIndex)
    })
  },
  methods: {
    handleResize () {
      setTimeout(() => {
        Plotly.Plots.resize(this.gd); // eslint-disable-line
      }, 500)
    }
  },

  watch: {
    dados: function (val, oldVal) { // eslint-disable-line
      if (val === oldVal) {
        return
      }
      this.gd.data = this.dados
      Plotly.redraw(this.gd)
    },
    layout () {
      Plotly.update(this.nomeDiv, this.dados, this.layout)
    }
  }
}
</script>

<style lang="scss">
  div.plotly-notifier {
    visibility: hidden;
  }
  .justify-items-center .plot-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/shared/AppPlotly.vue